/**
 * Returns a list of verifications for the given list of adapters, filtered by the given filter (if any).
 */
export function getVerificationData(adapters, filter = {}) {
    return adapters
        .reduce((verificationData, adapter) => {
        return verificationData.concat(adapter.getVerificationData());
    }, [])
        .filter((verificationData) => {
        return Object.keys(filter)
            .map((key) => key)
            .every((key) => verificationData[key] === filter[key]);
    });
}
